import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import axios from "axios";
import ReactGA from "react-ga4";
import ReCAPTCHA from "react-google-recaptcha";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import SnackBar from "@material-ui/core/Snackbar";

import Divider from "@material-ui/core/Divider";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import {
  DEFAULT_TIME_ZONE,
  BRANCH_LOCATION,
  BRANCH_LOCATION_MAP,
  BRANCH_NAME,
  BranchURLs,
  DEFAULT_DATE_FORMAT,
  LOGO_HORIZONTAL,
  COMPANY_NAME,
} from "../../../scripts/const";
import { Helmet } from "react-helmet";
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import HBGInfo from "../../../components/HBGInfo/ContactInfo";
import ThankYou from "../../../components/HBGInfo/Thankyou.js";
import { google, ics } from "calendar-link";
import { APPOINTMENT_USER_GET_REQUESTED } from "../../../redux/actions";
import Avatar from "@material-ui/core/Avatar";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { getDropDown, isValidPhone } from "../../../scripts/util";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";

import {
  Stepper,
  Step,
  StepButton,
  StepLabel,
  Typography,
  Button,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  Box,
} from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import DropDownWithSearch from "components/DropDownWithSearch/DropDownWithSearch";
import { DEFAULT_EMAIL_A } from "variables/general";

const useStyles = makeStyles(styles);
moment.tz.setDefault(DEFAULT_TIME_ZONE);

function Iframe(props) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
    />
  );
}

export default function Appointment() {
  const classes = useStyles();
  const recaptchaRef = React.useRef();

  const appointmentUsers = useSelector(
    (state) => state.appointment.appointmentUsers
  );
  const [isNewUser, setIsNewUser] = React.useState(null);
  const [isYearPickerOpen, setIsPickerOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [sending, setSending] = React.useState(false);
  const [finalAppointment, setFinalAppointment] = React.useState({});
  const [availableSlots, setAvailableSlots] = React.useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] =
    React.useState(false);
  const [confirmationTextVisible, setConfirmationTextVisible] =
    React.useState(false);
  const [smallScreen] = React.useState(window.innerWidth < 768);
  const [confirmationSnackbarOpen, setConfirmationSnackbarOpen] =
    React.useState(false);
  const [confirmationSnackbarMessage, setConfirmationSnackbarMessage] =
    React.useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: APPOINTMENT_USER_GET_REQUESTED });
  }, []);

  useEffect(() => {
    if (appointmentUsers && appointmentUsers.length > 0) {
      setAppointmentOwner(`${appointmentUsers[0].id}`);
    }
  }, [appointmentUsers]);

  const [appointmentDate, setAppointmentDate] = React.useState();
  const [appointmentOwner, setAppointmentOwner] = React.useState(null);
  const [appointmentSlot, setAppointmentSlot] = React.useState(null);
  const [amPm, setAmPm] = React.useState("AM");
  const [userInfo, setUserInfo] = React.useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    country: "",
  });
  const [processed, setProcessed] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [serviceSelected, setServiceSelected] = React.useState({
    student: false,
    visa: false,
    skillAssessment: false,
    healthInsurance: false,
    other: false,
  });
  const [stepIndex, setStepIndex] = React.useState(0);

  const handleNext = () => {
    setStepIndex((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setStepIndex((prevStep) => prevStep - 1);
  };

  const handleReset = () => {
    setStepIndex(0);
  };

  const isServiceSelected = () => {
    return Object.keys(serviceSelected).some((k) => serviceSelected[k]);
  };

  const isUserInfoCompleted = () => {
    return Object.keys(userInfo).every((k) => userInfo[k]);
  };

  const handleService = (event) => {
    setServiceSelected({
      ...serviceSelected,
      [event.target.name]: event.target.checked,
    });
  };
  function handleNextStep() {
    return stepIndex < 4 ? setStepIndex(stepIndex + 1) : null;
  }

  const handleAmPm = (event) => {
    setAmPm(event.target.value);
  };

  const handleAppointmentOwnerSelect = (event) => {
    setAppointmentOwner(event.target.value);
    setAppointmentSlot(null);
    setAmPm("AM");
    if (appointmentDate) {
      handleSetAppointmentDate(appointmentDate, event.target.value);
    }
  };
  const isSlotValid = (slot) => {
    if (!slot || !slot.userId) {
      return false;
    }
    return !(!(slot.userId.length > 0) || !slot.start || !slot.end);
  };
  const fetchAvailableAppointments = (date, userId, callback) => {
    const formattedDate = moment(date).format("YYYY-MM-DD").toString();
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_ROOT}/public/appointment?date=${formattedDate}&userId=${userId}`
      )
      .then((response) => {
        setLoading(false);
        callback(response.data, null);
      })
      .catch((error) => {
        setLoading(false);
        if (!error.response) {
          // network error
          callback(null, "Network Error, please try again later");
        } else {
          callback(null, "Sorry, some error occurred. Please try again.");
        }
      });
  };

  function handleSetAppointmentDate(date, userId) {
    setAppointmentDate(date);
    if (!date) {
      return;
    }
    setConfirmationTextVisible(true);
    fetchAvailableAppointments(date, userId, (data, error) => {
      if (error) {
        setConfirmationSnackbarMessage(error);
        setConfirmationSnackbarOpen(true);
      }
      if (data) {
        setAvailableSlots(
          data.map((m) => ({
            ...m,
            ...{ slot: moment(m.start).format("hh:mm A") },
          }))
        );
        setLoading(false);
        handleNextStep();
      }
    });
  }

  function handleSetAppointmentSlot(slot) {
    setAppointmentSlot(slot);
    handleNextStep();
  }

  function getLeadServiceTypes(services) {
    const applicableServices = Object.keys(services).filter(function (k) {
      return serviceSelected[k];
    });
    const leadServiceTypes = [];
    for (let ser of applicableServices) {
      if (ser === "student") {
        leadServiceTypes.push("Education");
      } else if (ser === "visa") {
        leadServiceTypes.push("Visa");
      } else if (ser === "skillAssessment") {
        leadServiceTypes.push("Skill Assessment");
      } else if (ser === "healthInsurance") {
        leadServiceTypes.push("Health Insurance");
      } else if (ser === "other") {
        leadServiceTypes.push("Other");
      }
    }
    return JSON.stringify(leadServiceTypes);
  }
  const handleSubmit = async () => {
    setIsError(false);

    const aptOwner = appointmentOwner
      ? appointmentUsers.find((u) => u.id == appointmentOwner)
      : null;
    let captcha;
    try {
      captcha = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
    } catch (e) {
      setIsError(true);
      setConfirmationSnackbarMessage("Something went wrong. Please try again.");
      return;
    }
    let services = Object.keys(serviceSelected)
      .filter(function (k) {
        return serviceSelected[k];
      })
      .join(", ");
    const slot = availableSlots.find((av) => av.slot === appointmentSlot);
    const fullName = userInfo.name.split(" ");
    let description = `Name: ${userInfo.name}\nEmail: ${userInfo.email}\nPhone: ${userInfo.phone}\nSelected Services: ${services}`;
    let title = `${userInfo.name} - Online Appointment`;
    if (aptOwner.isPaid && aptOwner.paidAmount) {
      title += ` (Fee: $${aptOwner.paidAmount})`;
    }
    if (!isSlotValid(slot)) {
      setConfirmationSnackbarMessage(
        "Sorry, something went wrong. Please refresh the page and try again."
      );
      setConfirmationSnackbarOpen(true);
      setProcessed(false);
      setIsError(true);
      return;
    }
    const appointment = {
      title,
      start: slot.start,
      end: slot.end,
      timezone: slot.timezone,
      userId: slot.userId,
      description,
      raw: {
        firstName: fullName[0],
        lastName: fullName[1] || "",
        email: userInfo.email,
        phone: userInfo.phone,
        serviceType: getLeadServiceTypes(serviceSelected),
        status: "New",
        note: "<i>Lead auto created from Online Appointment</i>",
      },
    };
    setFinalAppointment(appointment);
    const updatedEvent = {
      title: appointment.title || "New Event",
      description: appointment.description || "",
      location: `${COMPANY_NAME}, ${BRANCH_LOCATION}`,
      start: moment(appointment.start).toISOString(),
      end: moment(appointment.end).toISOString(),
    };
    const appointConfirm = {
      email: userInfo.email,
      data: {
        isPaid: aptOwner.isPaid,
        paidAmount: aptOwner.paidAmount,
        slotInfo: `${moment(appointmentDate).format(
          "dddd[,] MMMM Do[,] YYYY"
        )} at ${appointmentSlot}`,
        slotInfoShort: `${moment(appointmentDate).format(
          DEFAULT_DATE_FORMAT
        )} at ${appointmentSlot}`,
        name: userInfo.name,
        phone: userInfo.phone,
        country: userInfo.country,
        message: userInfo.message,
        googleLink: google(updatedEvent),
        iCalLink: ics(updatedEvent),
      },
    };
    axios
      .post(
        `${process.env.REACT_APP_API_ROOT}/public/appointment`,
        appointment,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            captcha,
          },
        }
      )
      .then(() => {
        setSending(false);
        setConfirmationSnackbarMessage("Appointment successfully added!");
        setConfirmationSnackbarOpen(true);
        setProcessed(true);
        setConfirmationModalOpen(false);
        ReactGA.event({
          category: "Public-Appointment",
          action: "Appointment Created",
        });
        if (DEFAULT_EMAIL_A === aptOwner?.email) {
          axios
            .post(
              `${process.env.REACT_APP_SMS_EMAIL}/appointmentConfirmationPaymentRequired`,
              appointConfirm
            )
            .then(() => {
              ReactGA.event({
                category: "Public-Appointment",
                action: "Confirmation Email Sent",
              });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          axios
            .post(
              `${process.env.REACT_APP_SMS_EMAIL}/appointmentConfirmation`,
              appointConfirm
            )
            .then(() => {
              ReactGA.event({
                category: "Public-Appointment",
                action: "Confirmation Email Sent",
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        setSending(false);
        if (error.response) {
          setConfirmationSnackbarMessage(error.response.data.message);
        } else {
          setConfirmationSnackbarMessage("Error Occurred. Please try again.");
        }
        handleSetAppointmentDate(appointmentDate, appointmentOwner);
        setAppointmentSlot(null);
        setStepIndex(3);
        setConfirmationSnackbarOpen(true);
        setProcessed(false);
        setIsError(true);
      });
  };

  function checkForEmail(email) {
    setIsNewUser(true);
    // axios
    //   .get(
    //     `${process.env.REACT_APP_API_ROOT}/public/checkClient?email=${email}`
    //   )
    //   .then((response) => setIsNewUser(!response.data.isValidClient))
    //   .catch((error) => {
    //     console.log("Error", error);
    //   });
  }
  function validateEmail(email) {
    const regex =
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    regex.test(email)
      ? setUserInfo({ ...userInfo, ...{ email: email, validEmail: true } })
      : setUserInfo({ ...userInfo, ...{ email: email, validEmail: false } });
  }

  function validatePhone(phoneNumber) {
    const re = /^[0-9+]*$/;
    if (phoneNumber !== "" && !re.test(phoneNumber)) {
      return;
    }
    isValidPhone(phoneNumber)
      ? setUserInfo({
          ...userInfo,
          ...{ phone: phoneNumber, validPhone: true },
        })
      : setUserInfo({
          ...userInfo,
          ...{ phone: phoneNumber, validPhone: false },
        });
  }

  function renderConfirmationString() {
    const spanStyle = { color: "#2684c4", fontWeight: 430 };
    const feeStyle = { color: "#e1261f", fontWeight: 430 };
    const aptOwner = appointmentOwner
      ? appointmentUsers.find((u) => u.id == appointmentOwner)
      : null;
    return confirmationTextVisible ? (
      <>
        <h3
          style={{
            textAlign: smallScreen ? "center" : "left",
            color: "#958F8FFF",
            // lineHeight: 1.5,
            padding: "10px 10px",
            fontFamily: "Roboto",
            position: "sticky",
            top: "0px",
            backgroundColor: "#FFF",
            zIndex: 99,
          }}
        >
          {
            <span>
              Scheduling a
              <span style={spanStyle}>
                {" "}
                {aptOwner && aptOwner.slotTime ? `${aptOwner.slotTime}` : "30"}
                minute{" "}
              </span>
              appointment{" "}
              {appointmentDate && appointmentSlot && (
                <span>
                  on{" "}
                  <span style={spanStyle}>
                    {moment(appointmentDate).format("dddd[,] MMMM Do")}
                  </span>{" "}
                  at <span style={spanStyle}>{appointmentSlot}</span>{" "}
                </span>
              )}{" "}
              {appointmentDate && !appointmentSlot && (
                <span>
                  <span style={spanStyle}>
                    {moment(appointmentDate).format("dddd[,] MMMM Do")}
                  </span>{" "}
                </span>
              )}
              {aptOwner && (
                <span>
                  with{" "}
                  <span style={spanStyle}>
                    {`${aptOwner.firstName} ${aptOwner.lastName}.`}
                  </span>{" "}
                </span>
              )}
              {aptOwner && aptOwner.isPaid && aptOwner.paidAmount && (
                <span>
                  <span style={feeStyle}>
                    Consultation Fee: ${aptOwner.paidAmount}.
                  </span>
                  {/*<span*/}
                  {/*  style={{*/}
                  {/*    fontStyle: "italic",*/}
                  {/*    margin: 0,*/}
                  {/*    display: "inline",*/}
                  {/*  }}*/}
                  {/*>*/}
                  {/*  (Fee for new clients only)*/}
                  {/*</span>*/}
                </span>
              )}
            </span>
          }
        </h3>
        <Divider></Divider>
      </>
    ) : null;
  }

  function renderAppointmentTimes() {
    if (!loading && availableSlots.length > 0) {
      const filteredSlot = availableSlots.filter((s) => s.slot.includes(amPm));
      return filteredSlot.map((slot) => {
        return (
          <FormControlLabel
            style={{
              color: slot.open ? "black" : "gray",
            }}
            key={slot.slot}
            value={slot.slot}
            disabled={!slot.open}
            control={<Radio />}
            label={slot.slot}
          />
        );
      });
    } else {
      return null;
    }
  }

  function getImg(user) {
    const makeCircle = appointmentOwner == user.id;
    const avatarStyle = {
      border: makeCircle ? "1.8px solid #EA3D5DFF" : "",
    };
    if (!user) {
      return <Avatar className={classes.purple}>""</Avatar>;
    }
    if (user.profileUrl) {
      return (
        <Avatar
          className={classes.aptAvatar}
          alt="profile-image"
          src={user.profileUrl}
          style={avatarStyle}
        />
      );
    } else {
      return (
        <Avatar style={avatarStyle} className={classes.purple}>
          {user.firstName.charAt(0).toUpperCase() +
            user.lastName.charAt(0).toUpperCase()}
        </Avatar>
      );
    }
  }

  function getAppointmentIcon(user) {
    const makeCircle = appointmentOwner == user.id;
    return (
      <div
        className={classes.aptUserInfo}
        style={{
          opacity: makeCircle ? "" : "0.8",
        }}
      >
        <div>{getImg(user)}</div>
        <div style={{ flexDirection: "row" }}>
          <div
            style={{ color: "#f35e7a", fontWeight: 500 }}
          >{`${user.firstName} ${user.lastName}`}</div>
          {user.isPaid && (
            <div>
              <p style={{ margin: 0, display: "inline", color: "#cc3300" }}>
                Consultation Fee - ${user.paidAmount}
              </p>
            </div>
          )}
          {user.appointmentNote && (
            <div>
              <p style={{ margin: 0, display: "inline", color: "#28a745" }}>
                {user.appointmentNote}
              </p>
            </div>
          )}
          <div style={{ color: "#646499" }}>
            {user.detail &&
              user.detail.split("\n").map((d, id) => (
                <p key={id} style={{ margin: 0 }}>
                  {d}
                </p>
              ))}
          </div>
        </div>
      </div>
    );
  }

  function renderAppointmentWith() {
    if (!loading && appointmentUsers.length > 0) {
      return appointmentUsers.map((user, id) => {
        return (
          <FormControlLabel
            key={id}
            value={`${user.id}`}
            control={<Radio />}
            labelPlacement={"end"}
            label={getAppointmentIcon(user)}
            style={
              appointmentOwner == user.id
                ? {
                    border: "1px solid red",
                    padding: "10px",
                    borderRadius: "8px",
                    marginBottom: "20px",
                  }
                : {
                    marginBottom: "20px",
                  }
            }
          />
        );
      });
    } else {
      return null;
    }
  }

  const [selectedBranch, setSelectedBranch] = React.useState("");

  const handleBranchChange = (name) => {
    const selected = BranchURLs.find((branch) => branch.name === name);
    setSelectedBranch(selected.name);
    window.location.href = selected.url; // Redirect to the selected branch's URL
  };

  function BranchDialog(props) {
    const { onClose, open } = props;

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Select Branch</DialogTitle>
        <List sx={{ pt: 0 }}>
          {BranchURLs.map((branch, id) => (
            <a style={{ textDecoration: "none" }} href={branch.url} key={id}>
              <ListItem button>
                <ListItemText primary={branch.name} />
              </ListItem>
            </a>
          ))}
        </List>
      </Dialog>
    );
  }

  // Confirmation##
  function renderAppointmentConfirmation() {
    const aptOwner = appointmentOwner
      ? appointmentUsers.find((u) => u.id == appointmentOwner)
      : null;
    const spanStyle = { color: "#00bcd4" };
    const feeStyle = { color: "#e1261f" };
    const infoStyle = { color: "#bbb6b6", fontStyle: "italic", margin: "0px" };

    return (
      <DialogContent className={classes.dialogContent}>
        <p>
          Name: <span style={spanStyle}>{userInfo.name}</span>
        </p>
        <p>
          Number: <span style={spanStyle}>{userInfo.phone}</span>
        </p>
        <p>
          Email: <span style={spanStyle}>{userInfo.email}</span>
          {/*<span style={{ fontStyle: "italic" }}>*/}
          {/*  {isNewUser ? " (New client)" : " (Returning Client)"}*/}
          {/*</span>*/}
        </p>
        <p>
          Appointment:{" "}
          <span style={spanStyle}>
            {moment(appointmentDate).format("dddd[,] MMMM Do[,] YYYY")}
          </span>{" "}
          <span style={spanStyle}>
            at <span style={spanStyle}>{appointmentSlot}</span>{" "}
          </span>
        </p>
        {aptOwner && (
          <p>
            With:{" "}
            <span style={spanStyle}>
              {aptOwner.firstName} {aptOwner.lastName}
            </span>
          </p>
        )}
        {aptOwner && aptOwner.isPaid && aptOwner.paidAmount && (
          <p>
            Fee: <span style={feeStyle}>${aptOwner.paidAmount}</span>{" "}
            <p style={infoStyle}>
              You can pay this fee at the office during your visit.
            </p>
            <p style={infoStyle}>We accept major credit cards / cash.</p>
          </p>
        )}
      </DialogContent>
    );
  }

  function disableWeekends(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  const { student, visa, skillAssessment, healthInsurance, other } =
    serviceSelected;
  const error =
    [student, visa, skillAssessment, healthInsurance, other].filter((v) => v)
      .length === 0;
  const contactFormFilled =
    userInfo.name &&
    userInfo.phone &&
    userInfo.email &&
    userInfo.validPhone &&
    userInfo.validEmail;

  const [branchModalOpen, setBranchModalOpen] = React.useState(false);
  const handleBranchModalOpen = () => {
    setBranchModalOpen(true);
  };
  const handleBranchModalClose = () => {
    setBranchModalOpen(false);
    setStepIndex(1);
  };

  const iframe = `<iframe
                    src=${BRANCH_LOCATION_MAP}
                    width="100%"
                    height="100%"
                    style="border:0;"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>`;

  const steps = [
    {
      label: `Branch - ${BRANCH_NAME}`,
      content: "BranchDialog",
    },
    { label: "Select a service", content: "Select a Service Content" },
    {
      label: "Choose an available day for your appointment",
      content: "Date Selection",
    },
    {
      label: "Choose an available time for your appointment",
      content: "Time Selection",
    },
    { label: "Share your contact information", content: "Contact Form" },
  ];

  const disableNext = (() => {
    switch (stepIndex) {
      case 0:
        return false;
      case 1:
        // Step 1: Require at least one service to be selected
        return !Object.values(serviceSelected).some(Boolean);
      case 2:
        // Step 2: Require an appointment date and appointment owner
        return !appointmentDate || !appointmentOwner;
      case 3:
        // Step 3: Require an AM/PM selection and a time slot
        return !amPm || !appointmentSlot;
      case 4:
        // Step 4: Require name, email, and phone information
        return !userInfo.name || !userInfo.email || !userInfo.phone;
      default:
        return false;
    }
  })();

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Schedule an Appointment | {COMPANY_NAME}</title>
        <meta
          name="description"
          content="Schedule an Appointment. Student | Visa | Skill Assessment | Insurance services"
        />
        <meta
          name="og:title"
          content={`Schedule Appointment for ${COMPANY_NAME})`}
        />
      </Helmet>
      <Card>
        <CardBody>
          <GridContainer justifyContent="center">
            <GridItem md={4} sm={8} xs={8}>
              <img className={classes.imgLogo} src={LOGO_HORIZONTAL} />
            </GridItem>
          </GridContainer>
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={8}>
              {processed ? (
                <ThankYou
                  appointment={finalAppointment}
                  isApt
                  summary={renderConfirmationString}
                />
              ) : (
                <Card>
                  {renderConfirmationString()}
                  <GridContainer>
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_CAPTCHA_INVISIBLE_KEY}
                      ref={recaptchaRef}
                      size="invisible"
                    />
                    <GridItem xs={12} sm={12}>
                      <h3 className={classes.titleApt}>
                        Schedule an Appointment - {BRANCH_NAME}
                      </h3>
                    </GridItem>
                    <GridItem xs={12} sm={12}>
                      <Box sx={{ maxWidth: "100%", padding: "20px" }}>
                        <Stepper activeStep={stepIndex} alternativeLabel>
                          {steps.map((step, index) => {
                            return (
                              <Step key={index}>
                                <StepLabel>{step.label}</StepLabel>
                              </Step>
                            );
                          })}
                        </Stepper>

                        <Box sx={{ mt: 2 }}>
                          {stepIndex === 0 && (
                            <Box>
                              {/* <StepButton
                                onClick={() => handleBranchModalOpen()}
                              >
                                <Typography variant="h6">
                                  Branch - {BRANCH_NAME}
                                </Typography>
                              </StepButton>

                              Branch Modal
                              <BranchDialog
                                open={branchModalOpen}
                                onClose={handleBranchModalClose}
                              /> */}
                              <Select
                                value={selectedBranch}
                                onChange={(e) =>
                                  handleBranchChange(e.target.value)
                                }
                                displayEmpty
                                renderValue={(value) => (
                                  <Typography variant="h6">
                                    Branch - {value || "Select Branch"}
                                  </Typography>
                                )}
                              >
                                {BranchURLs.map((branch) => (
                                  <MenuItem
                                    key={branch.url}
                                    value={branch.name}
                                  >
                                    {branch.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Box>
                          )}

                          {stepIndex === 1 && (
                            <Box>
                              <Typography variant="h6">
                                Select a Service
                              </Typography>
                              <FormControl
                                required
                                component="fieldset"
                                sx={{ marginTop: 2 }}
                              >
                                <FormLabel component="legend">
                                  At least select one
                                </FormLabel>
                                <FormGroup>
                                  {[
                                    "student",
                                    "visa",
                                    "skillAssessment",
                                    "healthInsurance",
                                    "other",
                                  ].map((service) => (
                                    <FormControlLabel
                                      key={service}
                                      control={
                                        <Checkbox
                                          checked={
                                            serviceSelected[service] || false
                                          }
                                          onChange={handleService}
                                          name={service}
                                        />
                                      }
                                      label={`${service.replace(
                                        /([A-Z])/g,
                                        " $1"
                                      )}`}
                                      sx={{
                                        color: serviceSelected[service]
                                          ? "text.primary"
                                          : "text.secondary",
                                      }}
                                    />
                                  ))}
                                </FormGroup>
                              </FormControl>
                            </Box>
                          )}

                          {stepIndex === 2 && (
                            <Box>
                              <Typography variant="h6">
                                Choose an available day for your appointment
                              </Typography>
                              <InputLabel htmlFor="appointmentOwner">
                                Appointment With:
                              </InputLabel>
                              <RadioGroup
                                style={{ marginTop: 10 }}
                                name="appointmentOwner"
                                value={appointmentOwner}
                                onChange={(event) =>
                                  handleAppointmentOwnerSelect(event)
                                }
                              >
                                {renderAppointmentWith()}
                              </RadioGroup>

                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  disablePast
                                  value={appointmentDate}
                                  onChange={(date) =>
                                    handleSetAppointmentDate(
                                      date,
                                      appointmentOwner
                                    )
                                  }
                                  format="MMM dd, yyyy"
                                  fullWidth
                                  InputProps={{ readOnly: true }}
                                  sx={{ marginTop: 2 }}
                                />
                              </MuiPickersUtilsProvider>
                            </Box>
                          )}

                          {stepIndex === 3 && (
                            <Box>
                              <Typography variant="h6">
                                Choose an available time for your appointment
                              </Typography>
                              <Select
                                value={amPm}
                                onChange={handleAmPm}
                                fullWidth
                              >
                                <MenuItem value="AM">AM</MenuItem>
                                <MenuItem value="PM">PM</MenuItem>
                              </Select>

                              <RadioGroup
                                name="appointmentTimes"
                                sx={{ marginTop: 2 }}
                                value={appointmentSlot}
                                onChange={(event) =>
                                  setAppointmentSlot(event.target.value)
                                }
                              >
                                {renderAppointmentTimes()}
                              </RadioGroup>
                            </Box>
                          )}

                          {stepIndex === 4 && (
                            <Box>
                              <Typography variant="h6">
                                Share your contact information
                              </Typography>
                              <GridContainer>
                                <GridItem xs={6} sm={6} md={6}>
                                  <TextField
                                    required
                                    label="Full Name"
                                    fullWidth
                                    value={userInfo.name}
                                    onChange={(event) =>
                                      setUserInfo({
                                        ...userInfo,
                                        name: event.target.value,
                                      })
                                    }
                                    sx={{ marginTop: 2 }}
                                  />
                                  <TextField
                                    required
                                    label="Email"
                                    fullWidth
                                    value={userInfo.email}
                                    onChange={(event) =>
                                      setUserInfo({
                                        ...userInfo,
                                        email: event.target.value,
                                      })
                                    }
                                    sx={{ marginTop: 2 }}
                                  />
                                </GridItem>
                                <GridItem xs={6} sm={6} md={6}>
                                  <TextField
                                    required
                                    label="Phone"
                                    fullWidth
                                    value={userInfo.phone}
                                    onChange={(event) =>
                                      setUserInfo({
                                        ...userInfo,
                                        phone: event.target.value,
                                      })
                                    }
                                    sx={{ marginTop: 2 }}
                                  />
                                  <DropDownWithSearch
                                    optionsList={getDropDown("country")}
                                    selectedOption={userInfo.country || ""}
                                    setValue={setUserInfo}
                                    currentState={userInfo}
                                    name={"country"}
                                    label={"Country"}
                                  />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                  <TextField
                                    id="outlined-multiline-static"
                                    label="Message"
                                    multiline
                                    rows={4}
                                    value={userInfo.message}
                                    onChange={(event) =>
                                      setUserInfo({
                                        ...userInfo,
                                        message: event.target.value,
                                      })
                                    }
                                    sx={{ marginTop: 2 }}
                                  />
                                </GridItem>
                              </GridContainer>

                              <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ marginTop: 3 }}
                                onClick={() => setConfirmationModalOpen(true)}
                                disabled={
                                  !userInfo.name ||
                                  !userInfo.email ||
                                  !userInfo.phone
                                }
                              >
                                Schedule
                              </Button>
                            </Box>
                          )}
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mt: 2,
                          }}
                        >
                          <Button
                            disabled={stepIndex === 0}
                            onClick={handleBack}
                          >
                            Back
                          </Button>
                          <Button
                            variant="contained"
                            onClick={
                              stepIndex === steps.length - 1
                                ? handleReset
                                : handleNext
                            }
                            disabled={disableNext}
                          >
                            {stepIndex === steps.length - 1 ? "Reset" : "Next"}
                          </Button>
                        </Box>
                      </Box>
                    </GridItem>
                  </GridContainer>
                </Card>
              )}
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <div
                className={classes.contact}
                style={{
                  position: "sticky",
                  top: "0px",
                }}
              >
                <h3
                  style={{
                    fontSize: "17px",
                    fontWeight: "500",
                    lineHeight: "1.5",
                    color: "#333",
                  }}
                >
                  Contact info
                </h3>
                <div className={classes.map}>
                  <Iframe iframe={iframe} />
                </div>
                <div className={classes.contactInfo}>
                  <div className={classes.contactItem}>
                    <HBGInfo isVertical />
                  </div>
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={confirmationModalOpen}
        title="Confirm your appointment"
      >
        <DialogTitle id="dialog-id">Confirm your appointment</DialogTitle>
        {renderAppointmentConfirmation()}
        {confirmationSnackbarMessage && isError && (
          <SnackbarContent
            message={confirmationSnackbarMessage}
            color="warning"
          />
        )}
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmationModalOpen(false);
              setIsError(false);
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              setSending(true);
              await handleSubmit();
              setSending(false);
            }}
            color="primary"
            autoFocus
            disabled={sending || isError}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <SnackBar
        open={confirmationSnackbarOpen || loading}
        message={loading ? "Loading... " : confirmationSnackbarMessage || ""}
        autoHideDuration={10000}
        onClose={() => setConfirmationSnackbarOpen(false)}
      />
    </div>
  );
}
